import { CustomerType } from "../../../interfaces/common/customer"
import { MerchantType } from "../../../interfaces/delivery-company/merchants"
import driver from "../../delivery-company-components/driver/driver"
import { IconWithText } from "./components"
import StorefrontIcon from "@mui/icons-material/Storefront"
import HomeIcon from '@mui/icons-material/Home';

interface CustomerWithIconProps {
    customer?: CustomerType | null
    centered?: boolean
    showPhone?: boolean

}
export const CustomerWithIcon = ({ customer, centered, showPhone, }: CustomerWithIconProps) => {
    if (!customer) return <></>
    return <div style={{ width: "100%", marginTop: 0, }}>
        <IconWithText centered={centered}> <HomeIcon color='primary' /><div style={{ display: "flex", flexDirection: "column", justifyItems: "center" }}><>{customer.name}</><>{showPhone && <> {customer.phone_number}</>}</></div> </IconWithText>
    </div>
}